import { useQuery } from "react-query";
import { useOrg } from ".";
import { fetchFindingCounts } from "../api";

/*
 * This hook returns the counts of findings for the current org
 */
export const useFindingCounts = () => {
  const org = useOrg();

  return useQuery(
    ["FindingCounts", { org }],
    () => fetchFindingCounts(org?.id!),
    { enabled: !!org }
  );
};
